import produce from "immer";
import axios from "axios";
import strings from "../../../res/strings";

import { setAppProcessing, setAppSuccess, setAppError } from "../../common";

export const AUTHENTICATE_ACCOUNT = "authentication/AUTHENTICATE_ACCOUNT";
export const SOCIAL_AUTHENTICATE_ACCOUNT =
  "authentication/SOCIAL_AUTHENTICATE_ACCOUNT";
export const SOCIAL_AUTHENTICATE_ACCOUNT_GOOGLE_SUCCESS =
  "authentication/SOCIAL_AUTHENTICATE_ACCOUNT_GOOGLE_SUCCESS";
export const LOGOUT_ACCOUNT = "authentication/LOGOUT_ACCOUNT";

const AUTHENTICATE_ACCOUNT_ERRORS = {
  DEFAULT: {
    message: strings.lib_common_state_error,
  },
  INVALID_CREDENTIALS: {
    message:
      strings.lib_authentication_state_error_authentication_invalid_credentials,
  },
};

const SOCIAL_AUTHENTICATE_ACCOUNT_ERRORS = {
  DEFAULT: {
    message: strings.lib_common_state_error,
  },
};

const initialState = {
  credentials: null,
};

export default (state = initialState, action) =>
  produce(state, (draft) => {
    switch (action.type) {
      case AUTHENTICATE_ACCOUNT: {
        draft.credentials = action.credentials;
        break;
      }

      case SOCIAL_AUTHENTICATE_ACCOUNT: {
        draft.credentials = action.credentials;
        break;
      }

      case LOGOUT_ACCOUNT: {
        draft.credentials = null;
        break;
      }

      default: {
        break;
      }
    }
  });

export const authenticateAccount = (
  { values, processingState, successState, errorState },
  history
) => {
  return (dispatch) => {
    dispatch(
      setAppProcessing(
        processingState ?? {
          context: "lib_authentication.authenticateAccount",
          message: strings.lib_common_state_loading,
        }
      )
    );

    console.log("AUTHENTICATE REQUEST");

    axios
      .post(
        process.env.REACT_APP_API_SERVER_HOST +
          process.env.REACT_APP_API_LIB_AUTHENTICATION_AUTHENTICATE_ACCOUNT,
        values
      )
      .then((response) => {
        const authToken = response.data.auth_token;
        const credentials = { authToken };

        dispatch({ type: AUTHENTICATE_ACCOUNT, credentials });
        dispatch(
          setAppSuccess(
            typeof successState === "function"
              ? successState(response, values)
              : successState ?? {
                  context: "lib_authentication.authenticateAccount",
                },
            history
          )
        );
      })
      .catch((errorResponse) => {
        let error = AUTHENTICATE_ACCOUNT_ERRORS.DEFAULT;
        if (errorResponse.response && errorResponse.response.status === 400) {
          error = AUTHENTICATE_ACCOUNT_ERRORS.INVALID_CREDENTIALS;
        }

        console.log("AUTHENTICATE ERROR");

        dispatch(
          setAppError(
            typeof errorState === "function"
              ? errorState(error, values)
              : errorState ?? {
                  notificationType: "alert",
                  context: "lib_authentication.authenticateAccount",
                  ...error,
                },
            history
          )
        );
      });
  };
};

export const socialAuthenticateAccount = (
  { values, processingState, successState, errorState },
  history
) => {
  return (dispatch) => {
    dispatch(
      setAppProcessing(
        processingState ?? {
          context: "lib_authentication.socialAuthenticateAccount",
          message: strings.lib_common_state_loading,
        }
      )
    );

    console.log("SOCIAL AUTHENTICATE REQUEST");

    axios
      .post(
        process.env.REACT_APP_API_SERVER_HOST +
          process.env
            .REACT_APP_API_LIB_AUTHENTICATION_SOCIAL_AUTHENTICATE_ACCOUNT,
        values
      )
      .then((response) => {
        console.log(response);
        const authToken = response.data.token;
        const credentials = { authToken };

        dispatch({ type: SOCIAL_AUTHENTICATE_ACCOUNT, credentials });
        dispatch(
          setAppSuccess(
            typeof successState === "function"
              ? successState(response, values)
              : successState ?? {
                  context: "lib_authentication.socialAuthenticateAccount",
                },
            history
          )
        );
      })
      .catch((errorResponse) => {
        let error = SOCIAL_AUTHENTICATE_ACCOUNT_ERRORS.DEFAULT;

        console.log("SOCIAL AUTHENTICATE ERROR");

        dispatch(
          setAppError(
            typeof errorState === "function"
              ? errorState(error, values)
              : errorState ?? {
                  ...error,
                  notificationType: "alert",
                  context: "lib_authentication.socialAuthenticateAccount",
                },
            history
          )
        );
      });
  };
};

export const logoutAccount = (
  { persistor, authToken, processingState, successState, errorState },
  history
) => {
  return (dispatch) => {
    dispatch(
      setAppProcessing(
        processingState ?? {
          context: "lib_authentication.logoutAccount",
          message: strings.lib_common_state_loading,
        }
      )
    );

    const requestHeaders = {
      "Content-Type": "application/json",
      Authorization: `Token ${authToken}`,
    };

    axios
      .post(
        process.env.REACT_APP_API_SERVER_HOST +
          process.env.REACT_APP_API_LIB_AUTHENTICATION_LOGOUT_ACCOUNT,
        {},
        { headers: requestHeaders }
      )
      .then((response) => {
        dispatch({ type: LOGOUT_ACCOUNT });
        dispatch(
          setAppSuccess(
            typeof successState === "function"
              ? successState(response)
              : successState ?? { context: "lib_authentication.logoutAccount" },
            history
          )
        );

        persistor.purge();
      })
      .catch((errorResponse) => {
        // The user is still logged out locally
        dispatch({ type: LOGOUT_ACCOUNT });
        dispatch(
          setAppSuccess(
            typeof successState === "function"
              ? successState(errorResponse)
              : successState ?? { context: "lib_authentication.logoutAccount" },
            history
          )
        );
        console.warn(
          strings.lib_authentication_state_warning_logout_localstorage
        );

        persistor.purge();
      });
  };
};
